








import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import Enumerable from 'linq';
import * as api from '@/api/api';
import * as def from '@/common/definitions';

@Component({
  components: {
  },
})
export default class GameDateTimePicker extends Vue {
  @Prop() public value!: api.GameDateTime;
  @Prop() public system?: api.SystemData;
  private currentValue: api.GameDateTime = new api.GameDateTime(0, 0);

  private mounted() {
    this.onValueChanged();
  }

  @Watch('value')
  private onValueChanged() {
    this.currentValue = new api.GameDateTime(parseInt(this.value.year.toString()),
      parseInt(this.value.month.toString()));
  }

  private generateNewValue(year: number, month: number): api.GameDateTime {
    return new api.GameDateTime(year, month);
  }
}
